// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Tq6qU","toggle":"styles_toggle__2x_Ft","preview":"styles_preview__3CbD9"};